import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AuthorSearch from './AuthorSearch';
import CategorySearch from './CategorySearch';
import Article from './Article';
import CategoryList from './CategoryList';
import AISearch from './AISearch';
import WhatsAppWidget from './components/WhatsAppWidget';

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<CategoryList />} />
        <Route path="/author/:authorID/:authorName" element={<AuthorSearch />} />
        <Route path="/category/:categoryID/:categoryName" element={<CategorySearch />} />
        <Route path="/article/:articleID" element={<Article />} />
        <Route path="/categoryList" element={<CategoryList />} />
        <Route path="/aisearch" element={<AISearch />} />
      </Routes>
      <WhatsAppWidget />
    </>
  );
}
